import { ProjectsTableColumnField } from "@components/table/projects/projects-table-types";

/** Columns to be displayed in the projects table */
export const requiredProjectTableColumns: ProjectsTableColumnField[] = [
  "name",
  "projectManager",
  "group",
  "created",
  "lastCaptured",
  "lastUpdated",
  "client",
  "size",
  "accessLevel",
  "options",
];
